import { useState } from "react";
import { ReactComponent as Trash } from "../../../assets/images/svg/trash.svg";
import { orderStyle } from "../../../theme/theme";
import CustomDropdownInput from "../../customFormElements/customDropdownInput/CustomDropdownInput";
import CustomNumberInput from "../../customFormElements/customNumberInput/CustomNumberInput";

const ProductItems = ({
  order,
  handleHingeChange,
  handleAmountChange,
  removeItemFromOrderListHandler,
}) => {
  const [selected, setSelected] = useState(-1);

  const setSelectedItem = (sku, index) => {
    return selected === index ? setSelected(-1) : setSelected(index);
  };
  const checkSelected = (index) => {
    if (selected === index) {
      return (
        "border border-btnEnd cursor-pointer bg-white flex  px-6 py-6 tablet:py-8  justify-items-stretch " +
        " rounded-2xl my-5 z-20 w-full transition transform duration-500 -translate-x-12 tablet:-translate-x-5"
      );
    } else {
      return "justify-items-stretch cursor-pointer [padding-left:24px]   bg-white rounded-2xl z-20 my-5 w-full transition transform duration-500";
    }
  };
  const trashClass = (index) => {
    return index === selected
      ? "absolute right-0 text-danger transition cursor-pointer transform duration-500 -translate-x-2 tablet:translate-x-2"
      : "absolute right-0 text-danger transition cursor-pointer transform duration-500 -translate-x-4 tablet:-translate-x-2";
  };
  return (
    <div className="[padding-right:2.5rem] overflow-y-auto z-0   flex-auto">
      {order.products.map((product, index) => {
        return (
          <div
            key={product.sku + index}
            className="flex relative justify-center items-center"
          >
            <h4
              className={
                "text-left " +
                orderStyle["titlesGray"] +
                " [width:89px] [height:23px]"
              }
            >
              #{product.sku}
            </h4>
            <div
              onClick={() => setSelectedItem(product.sku, index)}
              className={checkSelected(index)}
            >
              <div className="flex flex-col w-full ">
                {(product.hinge || product.drawer || product.isCustom) && (
                  <div className={" flex gap-2 absolute top-4 right-4"}>
                    {product.drawer && (
                      <span
                        title="Product has drawer."
                        className="px-2 bg-white w-auto text-txtBlack text-sm text-center font-bold h-7 rounded-full border flex items-center justify-center"
                      >
                        Drawer
                      </span>
                    )}
                  </div>
                )}

                <div className="flex w-full flex-wrap mt-3 tablet:mt-2 tablet:flex-nowrap">
                  <div className="flex flex-auto w-full tablet:w-1/2 flex-col ">
                    <h3 className={orderStyle["titleBlack"]}>{product.name}</h3>
                    <div className={orderStyle["description"]}>
                      {product.description}
                    </div>
                  </div>
                  <div className="mt-5 w-full justify-between flex-row-reverse tablet:flex-row tablet:mt-0 flex tablet:w-1/2 ">
                    <div
                      className="z-20 flex flex-col items-center [max-width:240px] tablet:w-1/2 tablet:flex-auto"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <CustomNumberInput
                        className="text-txtBlack scale font-bold  text-center text-lg w-12 focus:outline-none bg-transparent"
                        buttonClassName="w-6"
                        value={product.qty}
                        index={index}
                        min={1}
                        max={100}
                        products={order?.products}
                        setOrder={handleAmountChange}
                      />
                      <div className="tablet:flex-auto items-center tablet:w-1/2">
                        <div className={orderStyle["values"]}>
                          {"$" + (product.price * product.qty).toFixed(2)}
                        </div>
                      </div>
                    </div>
                    {product.hasHinging && (
                      <CustomDropdownInput
                        name="hinge"
                        className="appearance-none [width:100px] [height:45px] cursor-pointer focus:outline-none border rounded-lg  z-1 px-2 [background:white] [color:black]"
                        value={product.hinge}
                        products={order?.products}
                        index={index}
                        setProducts={handleHingeChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex-grow mx-4 border-t border-#D8D8D8 mt-4 opacity-1"></div>
            </div>

            <Trash
              onClick={() => {
                removeItemFromOrderListHandler(index);
                setSelected(-1);
              }}
              className={trashClass(index)}
            >
              X
            </Trash>
          </div>
        );
      })}
    </div>
  );
};
export default ProductItems;
